@if (convertedAltitude) {
  <p>{{convertedAltitude.toString()}}</p>
}
